import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { initialQuotationService } from '../services/initialQuotationService';

export const useInitialQuotations = (filters = {}) => {
  const queryClient = useQueryClient();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['initialQuotations', filters],
    queryFn: async () => {
      const response = await initialQuotationService.getInitialQuotations(filters);
      const leads = response.data?.data || response.data?.leads || response.data || [];
      return Array.isArray(leads) ? leads : [];
    },
    staleTime: 15 * 60 * 1000, 
    cacheTime: 30 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false, 
  });

  const updateMutation = useMutation({
    mutationFn: ({ id, data }) => initialQuotationService.submitInitialQuotation(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries(['initialQuotations']);
      queryClient.invalidateQueries(['leads']); 
    }
  });

  const deleteMutation = useMutation({
    mutationFn: (id) => initialQuotationService.deleteInitialQuotation(id),
    onSuccess: () => {
      queryClient.invalidateQueries(['initialQuotations']);
      queryClient.invalidateQueries(['leads']);
    }
  });
  
  const toggleDisableMutation = useMutation({
    mutationFn: ({ id, isDisabled }) => initialQuotationService.updateLead(id, { isDisabled }),
    onSuccess: () => {
      queryClient.invalidateQueries(['initialQuotations']);
      queryClient.invalidateQueries(['leads']);
    }
  });

  return {
    initialQuotations: data || [],
    isLoading,
    error,
    refetch,
    updateInitialQuotation: updateMutation.mutateAsync,
    deleteInitialQuotation: deleteMutation.mutateAsync,
    toggleDisableInitialQuotation: toggleDisableMutation.mutateAsync,
    isUpdating: updateMutation.isPending,
    isDeleting: deleteMutation.isPending,
  };
};
